// Page article individuel

import { useParams, Navigate } from "react-router-dom";
import { LandingHeader, LandingFooter } from "@/components/landing";
import {
  ArticleHero,
  ArticleContent,
  ArticleCTA,
  RelatedArticles,
} from "@/components/blog";
import { getArticleBySlug } from "@/data/articles";
import { usePageMeta } from "@/hooks/usePageMeta";
import { JsonLd } from "@/components/seo/JsonLd";

const BlogArticle = () => {
  const { slug } = useParams<{ slug: string }>();
  const article = slug ? getArticleBySlug(slug) : undefined;

  usePageMeta({
    title: article ? `${article.metaTitle} | B8ild` : "Blog B8ild",
    description: article?.metaDescription ?? "Articles et conseils pour la gestion de chantiers BTP.",
    url: `https://b8ild.fr/blog/${slug ?? ""}`,
  });

  // Rediriger vers la liste si l'article n'existe pas
  if (!article) {
    return <Navigate to="/blog" replace />;
  }

  return (
    <div className="min-h-screen bg-[#0F172A]">
      <JsonLd data={{
        "@context": "https://schema.org",
        "@type": "Article",
        headline: article.metaTitle,
        description: article.metaDescription,
        url: `https://b8ild.fr/blog/${article.slug}`,
        datePublished: article.publishedAt,
        dateModified: article.publishedAt,
        image: article.image ? `https://b8ild.fr${article.image}` : undefined,
        author: {
          "@type": "Organization",
          name: "B8ild",
          url: "https://b8ild.fr",
        },
        publisher: {
          "@type": "Organization",
          name: "B8ild",
          url: "https://b8ild.fr",
          logo: { "@type": "ImageObject", url: "https://b8ild.fr/logo-b8ild.png" },
        },
        mainEntityOfPage: { "@type": "WebPage", "@id": `https://b8ild.fr/blog/${article.slug}` },
      }} />
      <JsonLd data={{
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: [
          { "@type": "ListItem", position: 1, name: "Accueil", item: "https://b8ild.fr/" },
          { "@type": "ListItem", position: 2, name: "Blog", item: "https://b8ild.fr/blog" },
          { "@type": "ListItem", position: 3, name: article.metaTitle, item: `https://b8ild.fr/blog/${article.slug}` },
        ],
      }} />
      <LandingHeader />

      <main>
        {/* Hero de l'article */}
        <ArticleHero article={article} />

        {/* Contenu de l'article */}
        <section className="py-12 bg-[#0F172A]">
          <div className="container mx-auto px-4">
            <ArticleContent content={article.content} />
          </div>
        </section>

        {/* CTA fin d'article */}
        <ArticleCTA />

        {/* Articles similaires */}
        <RelatedArticles
          currentSlug={article.slug}
          currentCategory={article.category}
        />
      </main>

      <LandingFooter />
    </div>
  );
};

export default BlogArticle;
